import { apiCall } from "../../../shared/services/apiCall.js";
import { errorToast, successToast, helper } from "../../../shared/services/helper.js";
import dateTime from "@/shared/services/dateTime.js";
import store from "@/store/index.js";
import axios from "axios";
const prepareIconUpload = async (file, type) => {
    if (!file) return;
    const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    if (!allowedTypes.includes(file.type)) {
        return errorToast('Invalid file type');
    }
    try {
        const payload = {
            file_type: file.type,
            file_size: Math.round(file.size / 1024), // in KB
            file_name: file.name,
            type
        };

        const { data } = await apiCall('post', 'UPLOAD_AND_FETCH_QR_DATA', payload, 'wallet');

        if (!data?.success) {
            errorToast(data?.message || 'Failed to get upload URL');
            throw new Error(data?.message || 'Failed to get upload URL');
        }

        return await uploadIconToS3(data.data.url, file);
    } catch (err) {
        errorToast(err?.message || 'File upload failed');
        console.error('prepareIconUpload error:', err);
        throw err;
    }
};
const uploadIconToS3 = async (s3Url, file) => {
    try {
        const response = await axios.put(s3Url, file, {
            headers: {
                'Content-Type': file.type,
                'x-amz-acl': 'public-read'
            }
        });
        return s3Url.split("?")?.[0]
    } catch (err) {
        errorToast('S3 upload failed:', err.response?.status, err.response?.data || err.message)
        console.error('S3 upload failed:', err.response?.status, err.response?.data || err.message);
        throw new Error('Failed to upload icon to storage');
    }
};

const addAccount = async (paymentMethod, type, bankDetails, upiDetails ) => {
    try{
        let user = store.getters.stateUser;
        const is2faEnabled = user?.is_twofa_enable ?? false ;
        const userAccountData = {}
        userAccountData.payment_method= paymentMethod.method_type;
        if(type == 'bank'){
            userAccountData.method_id = bankDetails.method_id
            userAccountData.account_holder_name = bankDetails.account_holder_name
            userAccountData.account_number = bankDetails.account_no
            userAccountData.ifsc_code = bankDetails.ifsc_code
            userAccountData.transaction_password = is2faEnabled ? bankDetails.otp : bankDetails.withdrawal_password;
        } else {
            userAccountData.method_id = upiDetails.method_id
            userAccountData.account_holder_name = upiDetails.account_holder_name;
            if(type == 'upi'){
                userAccountData.upi_id = upiDetails.upi_id;
            }
            else{
                userAccountData.crypto_wallet_id = upiDetails.crypto_wallet_id
                userAccountData.crypto_type = 'USDT'
            }
            let res = await prepareIconUpload(upiDetails.qr_code, 'qr-code');
            userAccountData.qr_code = res;
            userAccountData.transaction_password = is2faEnabled ? upiDetails?.otp : upiDetails.withdrawal_password
        }
        let response = await apiCall('post', 'ADD_ACCOUNT',userAccountData, 'wallet')
        if (!response?.data?.success) {
            errorToast(response.data.message);
            return false
        }else{
            successToast(response?.data?.message);
            return true
        } 
    }catch(error){
        errorToast(error[0]);
        return false
    }
};
const openWithdrawPasswordModal = async () => {
    try{
        let response = await apiCall('post', 'SENT_OTP_TO_MOBILE', {}, 'wallet')
        if (!response?.data?.success) {
            errorToast(response?.data?.message);
            return {error : response?.data?.message }
        }else{
            successToast(response?.data?.message);
            return true
        } 
    }catch(error){
        errorToast(error[0]);
        return {error}
    }
};

const startWithdrawTimer = (updateFn) => {
    const startTime = new Date();
    const endTime = new Date(startTime.getTime() + 5 * 60 * 1000);
    let timeLeft = 5 * 60;
    let isResentOtpBtnVisiable = false;

    const timer = setInterval(() => {
        const currentTime = new Date();
        timeLeft = Math.floor((endTime - currentTime) / 1000);

        if (timeLeft <= 0) {
            clearInterval(timer);
            timeLeft = 0;
            isResentOtpBtnVisiable = true;
        }

        // Call the update function to sync state in Vue
        updateFn({ isResentOtpBtnVisiable, timeLeft, timer });
    }, 1000);
};
const stopTimer = (timer,isResentOtpBtnVisiable) => {
    isResentOtpBtnVisiable = false;
    clearInterval(timer);
};
export {
    addAccount,
    openWithdrawPasswordModal,
    startWithdrawTimer
}